import { useState, useEffect } from 'react';

interface UseHeaderParams {
  initialTab?: number;
  onTabChange?: (type: string, index: number) => void;
}

interface UseHeaderReturn {
  activeTab: number;
  switchTab: (index: number, type: string) => void;
  setActiveTab: (index: number) => void;
}

/**
 * Header 组件的 Tab 管理逻辑
 */
export function useHeader({ initialTab = 0, onTabChange }: UseHeaderParams = {}): UseHeaderReturn {
  const [activeTab, setActiveTab] = useState(initialTab);

  // 当 initialTab 变化时同步状态
  useEffect(() => {
    setActiveTab(initialTab);
  }, [initialTab]);

  const switchTab = (index: number, type: string) => {
    setActiveTab(index);
    onTabChange?.(type, index);
  };

  return {
    activeTab,
    switchTab,
    setActiveTab
  };
}
